/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_RequiredInputs */

const vi_carrier_legacy_required = /** @type {(inputs: Carrier_Legacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm "Đúng xã này" hoặc chọn xã khác`)
};

/**

* @param {Carrier_Legacy_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_required = /** @type {((inputs?: Carrier_Legacy_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_required(inputs)
});